"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
require("@hotmart/cosmos/dist/content-loader");
const ContentLoader = ({ width, height, style, className, ...rest }) => ((0, jsx_runtime_1.jsx)("hot-content-loader", { "data-test": "content-loader", style: { width, height, maxWidth: '100%', ...style }, class: className, ...rest }));
exports.default = ContentLoader;
